<div class="email-pricing-content">
    <mat-tab-group>
        <mat-tab [label]="tabNames.scheduleEmail" [aria-labelledby]="tabNames.scheduleEmail">
            <div class="schedule-email-container">
                <app-schedule-email
                    [tagList]="data?.tagList"
                    [recipientList]="recipientList"
                    (stateChange)="onScheduleStateChange($event)">
                </app-schedule-email>
            </div>
        </mat-tab>
        <mat-tab [label]="tabNames.customerEmails" [aria-labelledby]="tabNames.customerEmails">
            <div class="customer-email-grid-container">
                <app-customer-email-grid [dataSource]="gridData">
                </app-customer-email-grid>
            </div>
        </mat-tab>
    </mat-tab-group>

    <div class="dialog-actions">
        <button
            [disabled]="disableSendNow"
            (click)="onSendClick()"
            color="accent"
            mat-raised-button
            matTooltip="Sends the email immediately. Any scheduling settings will be ignored.">
            Send Email Now
        </button>
        <button
            [disabled]="disableSchedule"
            (click)="onScheduleClick()"
            color="accent"
            mat-raised-button>
            Schedule Email
        </button>
    </div>
</div>